import React from 'react';
import styles from './Article.module.scss';

const SectionTitle = ({ value }: { value: string }) => (
  <h2 className={styles.sectionTitle}>{value}</h2>
);

export default SectionTitle;
